var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMsgRtcVideo = function SvgIcMsgRtcVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 9.5835C1.6665 6.84393 1.6665 5.47414 2.42314 4.55219C2.56165 4.3834 2.71641 4.22864 2.88519 4.09013C3.80715 3.3335 5.17694 3.3335 7.9165 3.3335C10.6561 3.3335 12.0259 3.3335 12.9478 4.09013C13.1166 4.22864 13.2714 4.3834 13.4099 4.55219C14.1665 5.47414 14.1665 6.84393 14.1665 9.5835V10.4168C14.1665 13.1564 14.1665 14.5262 13.4099 15.4481C13.2714 15.6169 13.1166 15.7717 12.9478 15.9102C12.0259 16.6668 10.6561 16.6668 7.9165 16.6668C5.17694 16.6668 3.80715 16.6668 2.88519 15.9102C2.71641 15.7717 2.56165 15.6169 2.42314 15.4481C1.6665 14.5262 1.6665 13.1564 1.6665 10.4168V9.5835Z",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 7.91666L14.7151 7.64235C16.3367 6.83156 17.1475 6.42617 17.7403 6.79256C18.3332 7.15895 18.3332 8.06544 18.3332 9.87842V10.1216C18.3332 11.9346 18.3332 12.841 17.7403 13.2074C17.1475 13.5738 16.3367 13.1684 14.7151 12.3576L14.1665 12.0833V7.91666Z",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeWidth: 1.2
  })));
};
export default SvgIcMsgRtcVideo;